import React, { useEffect, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
	iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
	iconUrl: require("leaflet/dist/images/marker-icon.png"),
	shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// Helper component to update map center dynamically
function Recenter({ lat, lng }) {
	const map = useMap();
	useEffect(() => {
		map.setView([lat, lng]);
	}, [lat, lng, map]);
	return null;
}

export default function MMaps({ latitude, longitude, zoom = 15, popupText }) {
	if (latitude == null || longitude == null) return <p>Location not available</p>; // allow 0 coordinates

	const position = [latitude, longitude];

	return (
		<MapContainer
			center={position}
			zoom={zoom}
			scrollWheelZoom={false}
			className={"[&.leaflet-pane]:!z-0"}
			style={{ height: 400, width: "100%", borderRadius: 8, zIndex: 0 }}
		>
			<TileLayer
				attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
				url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
			/>
			<Marker position={position}>{popupText && <Popup>{popupText}</Popup>}</Marker>
			<Recenter lat={latitude} lng={longitude} />
		</MapContainer>
	);
}
